import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

type DimmingStateValue = string | boolean | number | Record<string, unknown> | unknown[];

/**
 * DimmingInterfaceStateService
 * --------------------------------------------------------------------
 * Centralises the DimmingInterface + MultiConfig reactive streams that
 * previously lived on `ApiService`.
 *
 * Public field / method names mirror the legacy `ApiService` API so
 * `ApiService` can delegate here without forcing consumer changes.
 */
@Injectable({ providedIn: "root" })
export class DimmingInterfaceStateService {
  readonly dimmingData = new BehaviorSubject<DimmingStateValue>("");
  readonly getDimmingData: Observable<DimmingStateValue> = this.dimmingData.asObservable();

  readonly multiconfigData = new BehaviorSubject<DimmingStateValue>("");
  readonly getMultiConfigData: Observable<DimmingStateValue> = this.multiconfigData.asObservable();

  readonly isDimmingValid = new BehaviorSubject<DimmingStateValue>("");
  readonly getValidDimming: Observable<DimmingStateValue> = this.isDimmingValid.asObservable();

  readonly settingItDefault = new BehaviorSubject<DimmingStateValue>("");
  readonly getrestoreDefault: Observable<DimmingStateValue> = this.settingItDefault.asObservable();

  readonly multiconfigDefault = new Subject<DimmingStateValue>();
  readonly getMulticonfigDefault: Observable<DimmingStateValue> = this.multiconfigDefault.asObservable();

  readonly isDimmingRestore = new BehaviorSubject<DimmingStateValue>("");
  readonly restoreDimming = new BehaviorSubject<DimmingStateValue>("");
  readonly getDimmingInterfaceRestored: Observable<DimmingStateValue> = this.restoreDimming.asObservable();

  readonly checkValidityofDimming = new BehaviorSubject<DimmingStateValue>("");
  readonly getDimmingValidity: Observable<DimmingStateValue> = this.checkValidityofDimming.asObservable();

  // --- Setters (names match legacy ApiService) ----------------------
  sendDimmingInterfacedata(data: DimmingStateValue): void {
    this.dimmingData.next(data);
  }
  sendMultiConfigData(data: DimmingStateValue): void {
    this.multiconfigData.next(data);
  }
  validtionOfDimming(data: DimmingStateValue): void {
    this.isDimmingValid.next(data);
  }
  sendDimmingCheckValidation(data: DimmingStateValue): void {
    this.checkValidityofDimming.next(data);
  }
  restoingDefault(data: DimmingStateValue): void {
    this.settingItDefault.next(data);
  }
  restoreMulticonfigDefault(data: DimmingStateValue): void {
    this.multiconfigDefault.next(data);
  }
  sendDimmingDefault(data: DimmingStateValue): void {
    this.isDimmingRestore.next(data);
  }
  sendDimmingRestoreDefault(data: DimmingStateValue): void {
    this.restoreDimming.next(data);
  }
}
